$(document).on('turbo:before-render', function(){
  if($('.rich-textarea').length == 0) { return; }
  window.tinymce.remove('.rich-textarea');
});

$(document).on('turbo:load turbo:render', function(){
  if($('.rich-textarea').length == 0) { return; }

  window.useDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  // const isSmallScreen = window.matchMedia('(max-width: 1023.5px)').matches;

  window.tinymce.init({
    selector: '.rich-textarea',
    plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
    editimage_cors_hosts: ['picsum.photos'],
    menubar: 'file edit view insert format tools table help',
    toolbar: "undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl",
    autosave_ask_before_unload: true,
    autosave_interval: '30s',
    autosave_prefix: '{path}{query}-{id}-',
    autosave_restore_when_empty: false,
    autosave_retention: '2m',
    image_advtab: true,
    link_list: [
      { title: 'My page 1', value: 'https://www.tiny.cloud' },
      { title: 'My page 2', value: 'http://www.moxiecode.com' }
    ],
    image_list: [
      { title: 'My page 1', value: 'https://www.tiny.cloud' },
      { title: 'My page 2', value: 'http://www.moxiecode.com' }
    ],
    image_class_list: [
      { title: 'None', value: '' },
      { title: 'Some class', value: 'class-name' }
    ],
    importcss_append: true,
    file_picker_callback: (callback, value, meta) => {
      /* Provide file and text for the link dialog */
      if (meta.filetype === 'file') {
        callback('https://www.google.com/logos/google.jpg', { text: 'My text' });
      }

      /* Provide image and alt text for the image dialog */
      if (meta.filetype === 'image') {
        callback('https://www.google.com/logos/google.jpg', { alt: 'My alt text' });
      }

      /* Provide alternative source and posted for the media dialog */
      if (meta.filetype === 'media') {
        callback('movie.mp4', { source2: 'alt.ogg', poster: 'https://www.google.com/logos/google.jpg' });
      }
    },
    height: 600,
    image_caption: true,
    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    noneditable_class: 'mceNonEditable',
    toolbar_mode: 'sliding',
    contextmenu: 'link image table',
    skin: window.useDarkMode ? 'oxide-dark' : 'oxide',
    content_css: window.useDarkMode ? 'dark' : 'default',
    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }'
    // setup: (editor) => {
    //   editor.on('init', (e) => {
    //     console.log('The Editor has initialized.');
    //   });
    //   editor.on('BeforeSetContent', function(event){
    //     var newContent = event.content;
    //     var parser = new DOMParser();
    //     var doc = parser.parseFromString(newContent, "text/html");

    //     // Find all img elements
    //     var images = doc.querySelectorAll('img');

    //     // Loop through each image and replace src with data-src
    //     for (var i = 0; i < images.length; i++) {
    //       var img = images[i];
    //       var src = img.getAttribute('src');
    //       img.setAttribute('data-src', src);
    //       // Remove the original src attribute
    //       img.removeAttribute('src');
    //     }

    //     // Update the content with modified images
    //     event.content = doc.documentElement.outerHTML;
    //   });
    // }
  });

  // window.tinymce.init({
  //   selector: '.rich-textarea',
  //   // toolbar: 'undo redo | styles | bold italic | link image',
  //   // block_formats: 'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3',
  //   // style_formats_autohide: true,
  //   style_formats: [
  //     { title: 'Headings', items: [
  //       { title: 'Heading 1', format: 'h1' },
  //       { title: 'Heading 2', format: 'h2' },
  //       { title: 'Heading 3', format: 'h3' },
  //       { title: 'Heading 4', format: 'h4' },
  //       { title: 'Heading 5', format: 'h5' },
  //       { title: 'Heading 6', format: 'h6' }
  //     ]},
  //     { title: 'Inline', items: [
  //       { title: 'Bold', format: 'bold' },
  //       { title: 'Italic', format: 'italic' },
  //       { title: 'Underline', format: 'underline' },
  //       { title: 'Strikethrough', format: 'strikethrough' },
  //       { title: 'Superscript', format: 'superscript' },
  //       { title: 'Subscript', format: 'subscript' },
  //       { title: 'Code', format: 'code' }
  //     ]},
  //     { title: 'Blocks', items: [
  //       { title: 'Paragraph', format: 'p' },
  //       { title: 'Blockquote', format: 'blockquote' },
  //       { title: 'Div', format: 'div' },
  //       { title: 'Pre', format: 'pre' }
  //     ]},
  //     { title: 'Align', items: [
  //       { title: 'Left', format: 'alignleft' },
  //       { title: 'Center', format: 'aligncenter' },
  //       { title: 'Right', format: 'alignright' },
  //       { title: 'Justify', format: 'alignjustify' }
  //     ]}
  //   ],
  //   toolbar: [
  //     { name: 'history', items: [ 'undo', 'redo' ] },
  //     { name: 'styles', items: [ 'styles' ] },
  //     { name: 'formatting', items: [ 'bold', 'italic' ] },
  //     { name: 'alignment', items: [ 'alignleft', 'aligncenter', 'alignright', 'alignjustify' ] },
  //     { name: 'indentation', items: [ 'outdent', 'indent' ] }
  //   ],
  //   promotion: false
  // });
});
